import * as React from 'react';
import {StorageSuccessModal} from "../../StorageSuccessModal";
import {AnnualPolicyPremiumTypeEnum, Policy} from "@falcon/services";
import {formatDateDMY, getAmountToDisplay} from "../../../../CommonFunctions";
import {
    EditCarMtaSuccessModalWordingGenerator
} from "../../../../pages/dashboard/annual/motor/yourCarsPage/modal/EditCarMtaSuccessModalWordingGenerator";
import PaymentSchedule from "../../../widgets/PaymentSchedule";

interface IProps {
    policy: Policy;
    cardEnding: string;
}

interface IState {
    isInstalmentPlanOpened: boolean;
}

export class GracePeriodRenewalStorageSuccessModal extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);

        this.state = {
            isInstalmentPlanOpened: false,
        };
    }

    public render(): React.ReactNode {
        let title: React.ReactNode;
        let content: React.ReactNode;
        let anythingElseTitle: React.ReactNode;
        let anythingElseWording: React.ReactNode;

        const factors: any = this.props.policy.interaction.factors;
        const policyEndDate: string | null = formatDateDMY(this.props.policy.endDate);

        if (factors.premiumType === AnnualPolicyPremiumTypeEnum.ANNUAL) {
                title = "Payment was successful";
                content =
                        <p className="mb-0">
                            <span className="font-weight-bold">{getAmountToDisplay(factors.annualPremium)}</span> has been been debited from your card ending <span className="font-weight-bold">{this.props.cardEnding}</span> to renew your home policy.<br/>
                        </p>
            }
        else if (factors.premiumType === AnnualPolicyPremiumTypeEnum.MONTHLY) {
            title = "You're good to go!"
            content =
            <div className="font-and-line-styles">
                <div className="font-weight-700">
                    <div>Your home insurance policy is now renewed.</div>
                    <div>You do not need to inform us of the change by email or do anything else.</div>
                </div>
                <div>Policy ends on {policyEndDate}.</div>
                <div className="mt-4 mb-4">
                    {this.renderMonthlyInfo()}
                </div>
            </div>
            anythingElseTitle = EditCarMtaSuccessModalWordingGenerator.generateAnythingElseChangedModalTitle();
            anythingElseWording = EditCarMtaSuccessModalWordingGenerator.generateAnythingElseChangedModalBody();
        }

        return <StorageSuccessModal title={title}
                                    explanationWording={content}
                                    anythingElseTitle={anythingElseTitle}
                                    explanationAnythingElseWording={anythingElseWording}
        />
    }

    private renderMonthlyInfo(): React.ReactNode {
        const instalmentPlan: any = this.props.policy.interaction.paymentDetails.instalmentPlan;
        const initialPaymentDate: string | null = formatDateDMY(instalmentPlan.instalments[0].dueDate);
        const firstInstallmentPayAmount = instalmentPlan.instalments[0].principal + instalmentPlan.instalments[0].interest;

        return <>
            <p className="mb-4">The first instalment of <span className="font-weight-bold">{getAmountToDisplay(firstInstallmentPayAmount)}</span> will be taken
                on {initialPaymentDate}. Please check your payment schedule below.</p>
            <label htmlFor="paymentScheduleTable" className="text-center">
                <div className="font-weight-700 mt-1">Payment schedule</div>
            </label>
            <p className="mb-2 mt-1">You have to pay a total of <span
                className="font-weight-bold">{getAmountToDisplay(instalmentPlan.totalAmount)} </span>
                ({instalmentPlan.instalments.length} instalments X {getAmountToDisplay(instalmentPlan.monthlyPayment)})</p>
            <div id="paymentScheduleTable" className="mb-3 mt-3">
                <PaymentSchedule
                    isOpen={this.state.isInstalmentPlanOpened}
                    instalments={instalmentPlan.instalments || []}
                />
            </div>
            <div className="text-left mt-4">
                {!this.state.isInstalmentPlanOpened ?
                    <button
                        className="btn-inner-link btn-text text-center cursor-pointer text-decoration-none mb-4"
                        onClick={this.toggleInstallmentPlan}>
                        + <span className="text-decoration-underline">View instalments plan</span>
                    </button>
                    :
                    <button
                        className="btn-inner-link btn-text text-center cursor-pointer text-decoration-none mb-4"
                        onClick={this.toggleInstallmentPlan}>
                        - <span className="text-decoration-underline">Hide instalments plan</span>
                    </button>
                }
            </div>
        </>;
    }

    private toggleInstallmentPlan = (): void => {
        this.setState((prevState: Readonly<IState>) => (
            {isInstalmentPlanOpened: !prevState.isInstalmentPlanOpened})
        )
    }
}
